<template>
    <div class="modal-overlay" v-if="abrirModal == id">
        <div class="modal-content">
            <div class="modal-icon">
                <div class="outer-circle"></div>
                <div class="middle-circle"></div>
                <div class="inner-circle">
                    <div class="inner-border">!</div>
                </div>
            </div>
            <div class="modal-header">
                <h4>{{titulo}}</h4>
            </div>
            <div class="modal-body">
                <p class="subtitle" v-if="mensagem">
                    {{ mensagem }}<br/>
                </p>    
                <p>
                    {{labelOpcoes}}
                </p> 
            </div>
            <div class="modal-footer">
                <button v-for="(botao, index) in botoes" :key="index" @click="executar(botao)">{{botao.texto}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: ['titulo', 'mensagem', 'botoes', 'labelOpcoes', 'id'],
    computed: {
        ...mapGetters({
            abrirModal: 'GET_MODAL_AVISO'
        })
    },
    methods: {
        executar(botao){
            if (typeof botao.acao === 'function') {
                botao.acao();
                this.closeModal();
            } else if (botao.emit) {
                this.closeModal();
            }
        },
        closeModal() {
            this.$store.commit('SET_MODAL_AVISO', false);
            
        }
    }
};
</script>

